import { useMemo } from 'react'
import { useAppSelector } from '@/hooks'
import {
  programsNewCollection,
  selectAvailablePrograms,
} from '@/reducers/programsNew'
import { Device, DeviceSelection } from '../DeviceSelectionGallery.types'
import { computeBestAutoSelectDevice } from './computeBestAutoSelectDevice'

type Result = {
  bestDevice: DeviceSelection | null
  isProgramsLoading: boolean
  hasAvailablePrograms: boolean
}

export function useBestDeviceForAutoSelect(devices: Device[]): Result {
  const { isLoadingOrIdle } = programsNewCollection.useFetch()
  const availablePrograms = useAppSelector(selectAvailablePrograms())

  const bestDevice = useMemo(
    () => computeBestAutoSelectDevice(devices, availablePrograms),
    [devices, availablePrograms],
  )

  return {
    bestDevice,
    isProgramsLoading: isLoadingOrIdle,
    hasAvailablePrograms: availablePrograms.length > 0,
  }
}
